<div [hidden]="!active" class="pane">
  <ng-content></ng-content>
</div>
